<script setup>
import ErrorBoundary from "@/components/shared/error-boundary/ErrorBoundary";
</script>

<template>
  <ErrorBoundary :name="$route.path">
    <router-view />
  </ErrorBoundary>
</template>
